export const SUCCESS_FETCH_EXPEDITING = 'SUCCESS_FETCH_EXPEDITING';
export const FAIL_FETCH_EXPEDITING = 'FAIL_FETCH_EXPEDITING';
export const SUCCESS_SHOW_EXPEDITING = 'SUCCESS_SHOW_EXPEDITING';
export const FAIL_SHOW_EXPEDITING = 'FAIL_SHOW_EXPEDITING';
export const SUCCESS_STORE_EXPEDITING = 'SUCCESS_STORE_EXPEDITING';
export const FAIL_STORE_EXPEDITING = 'FAIL_STORE_EXPEDITING';
export const SUCCESS_SHOW_STATUS_INOVOICE_BARANG = 'SUCCESS_SHOW_STATUS_INVOICE_BARANG';
export const FAIL_SHOW_STATUS_INOVOICE_BARANG = 'FAIL_SHOW_STATUS_INVOICE_BARANG';

export const RESET_STATUS_INVOICE = 'RESET_STATUS_INVOICE';
